<header>
    <div class="overlay">
        <div class="dive">
            <img class="img-fluid saturate " src="/assets/logo/website_logo_transparent_background.png" alt="">
            <h1>Pepiniera locala de plante ornamentale</h1>
            <h3>Avem placerea de a aduce in casele si gradinile dumneavoastra mai multe sortimente de plante
                ornamentale.
            </h3>
            <h3>Navigand pe site-ul nostru veti putea gasi diverse soiuri de plante ornamentale atat pentru gradina
                dumneavoastra, cat si pentru interior - terase inchise.</h3>
        </div>
    </div>
</header>